import React, { useState, useEffect } from "react";
import SingleChart from "./SingleChart";
import ApiService from "../../../../ApiService";
import { format_yyyy_mm_dd_to_DATETIME_MED } from "../../../../util/common";
import { Form } from "react-bootstrap";
import { Button } from "react-bootstrap";
import CreateChartNotesModal from "../../../Common/popUpModals/CreateChartNotesModal";

function convertEpochToDate(createdEpoch) {
  // Convert seconds to milliseconds (Epoch timestamps are usually in seconds)
  const milliseconds = createdEpoch * 1000;

  // Create a new Date object using the milliseconds
  const dateObject = new Date(milliseconds);

  // Get the month, day, and year from the date object
  const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  const day = dateObject.getDate();
  const monthIndex = dateObject.getMonth();
  const year = dateObject.getFullYear() % 100; // Get only last two digits of the year

  // Format the date as 'DD Mon 'YY
  const formattedDate = `${day} ${monthNames[monthIndex]}'${year.toString().padStart(2, "0")}`;

  return formattedDate;
}
export default function ChartingNotes({ patientId, patientDetail, viewId }) {
  const [chartNotes, setChartNotes] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [showCreateChartNotesModal, setShowCreateChartNotesModal] = useState(false);
  const [expandedNoteId, setExpandedNoteId] = useState(null);
  const getNotes = async () => {
    setIsLoading(true);
    try {
      const response = await ApiService.getChartingNotesWithPatientId(patientId);
      if (Array.isArray(response?.data)) {
        setChartNotes(response.data);
        if (typeof viewId === "string") {
          const matchedNote = response.data.find(note => String(note.id) === viewId);
          if (matchedNote) {
            setExpandedNoteId(matchedNote.id.toString());
          }
        }
      } else {
        setChartNotes([]);
      }
      setIsLoading(false);
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }
  };
  useEffect(() => {
    getNotes();
  }, [patientId, viewId]);



  return (
    <div className="dashboardContent">
      <div className="dashboardHeader">
        <div className="chartingSearch">
          <Form.Control type="text" placeholder="Search" value={search} onChange={e => setSearch(e.target.value)} />
        </div>
        {search.length > 0 && (
          <span className="resetText" onClick={() => setSearch("")}>
            Reset
          </span>
        )}
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            flex: 1,
            alignItems: "center",
            padding: "10px 20px",
          }}
          onClick={() => setShowCreateChartNotesModal(true)}
        >
          <Button variant="success" onClick={() => {}}>
            Create Charting Note
          </Button>
        </div>
      </div>

      <CreateChartNotesModal
        show={showCreateChartNotesModal}
        onHide={() => setShowCreateChartNotesModal(false)}
        patientId={patientId}
        patientDetails={patientDetail}
        cb={getNotes}
      />

      <div className="patientInfo" style={{ marginLeft: "4px" }}>
        <p>
          <strong>Patient Name:</strong>&nbsp;{patientDetail?.name}
        </p>
        <p>
          <strong>DOB:</strong>&nbsp;
          {format_yyyy_mm_dd_to_DATETIME_MED(patientDetail?.dob)}
        </p>
      </div>

      {chartNotes.length > 0 ? (
        <div className="tabsContent px-4">
          {chartNotes
            .slice()
            .reverse()
            .map((el, index) => (
              <SingleChart
                search={search}
                key={index}
                chartStatus={el?.status}
                referenceId={el.referenceId}
                isClinicalRequired={el.authorName ? false : true}
                authorName={el.authorName ?? el.authorId ?? "Unknown"}
                createdDate={convertEpochToDate(el.createdEpoch)}
                chartDetails={el}
                noteMessage={el.note}
                patientDetail={patientDetail}
                cb={getNotes}
                isExpanded={String(el.id) === String(expandedNoteId)}
              />
            ))}
        </div>
      ) : (
        <div className="tabsContent px-4">{isLoading ? <p className="loading"></p> : <h1 className="noRecordFound">No Charting Notes found</h1>}</div>
      )}
    </div>
  );
}
